import React, { Component } from 'react';
import { SimpleForm, TextInput, Toolbar, SaveButton, ReferenceInput, SelectInput, translate } from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

function TipoProyectoToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

class TipoProyectoForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props} toolbar={<TipoProyectoToolbar />}>
        {this.props.children}
        <FieldGroup label="fieldGroups.tipoProyectoEs">
          <TextInput source="name" validate={isRequired} />
        </FieldGroup>
        <FieldGroup label="fieldGroups.tipoProyectoEn">
          <TextInput source="nameEn" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.tipoProyectoPt">
          <TextInput source="namePt" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.tipoProyecto">
          <ReferenceInput source="subsector" reference="subsectores" validate={isRequired}>
            <SelectInput optionText="name" />
          </ReferenceInput>
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(TipoProyectoForm);
